export const SET_PROFILE = 'SET_PROFILE'
export const CLEAR_PROFILE = 'CLEAR_PROFILE'

export type SetProfileAction = {
    type: typeof SET_PROFILE | typeof CLEAR_PROFILE
    profile: LoginInType
}

export const setProfile = (profile: LoginInType): SetProfileAction => ({
    type: SET_PROFILE,
    profile,
})

export const clearProfileData = () => ({
    type: CLEAR_PROFILE,
})
